import { render, staticRenderFns } from "./ModalResetPassword.vue?vue&type=template&id=66c1035a"
import script from "./ModalResetPassword.vue?vue&type=script&lang=js"
export * from "./ModalResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ModalResetPassword.vue?vue&type=style&index=0&id=66c1035a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports